import { Skeleton } from "antd";
import React from "react";

const LinkPreviewLoader = () => {
    return (
        <>
            {
                <>
                    <Skeleton.Image className="w-100" />
                    <div className="card-body d-flex justify-content-between">
                        <Skeleton.Input active size={"small"} />
                        <Skeleton.Input active size={"small"} />
                        <Skeleton.Input active size={"small"} />
                    </div>
                </>
            }
        </>
    )
};

export default LinkPreviewLoader;